import { ConfirmAlert } from '@carboncopyco/ui';

type DiscardChangesModalProps = {
  onDiscard: () => void;
  onCancel: () => void;
};

export const DiscardChangesModal = ({
  onCancel,
  onDiscard,
}: DiscardChangesModalProps) => {
  return (
    <ConfirmAlert
      danger
      title="Unsaved changes"
      description="Are you sure you want to continue? Your changes will not be saved."
      show={true}
      onConfirm={onDiscard}
      onClose={onCancel}
      yesLabel="Discard changes"
      noLabel="Keep editing"
    />
  );
};
